import isServerSideRendering from './isServerSideRendering';

const NATIVE_APP_UA = /CarvanaNativeWebView|Carvana\/|Dalvik\//i;

const IsCarvanaMobileAppUserAgent = (userAgent?: string | undefined) => {
  if (isServerSideRendering) {
    return false;
  }
  const agentString = userAgent || navigator.userAgent;
  return NATIVE_APP_UA.test(agentString);
};

export const isAndroidCarvanaMobileAppUserAgent = (userAgent?: string | undefined) => {
  if (isServerSideRendering) {
    return false;
  }
  const agentString = userAgent || navigator.userAgent;
  return IsCarvanaMobileAppUserAgent(agentString) && /Android/i.test(agentString);
};

export default IsCarvanaMobileAppUserAgent;
